<template>
  <div id="academic">
    <el-container>
      <el-aside width="200px">
        <div class="catalog">
          <h5 style="font-size: 20px" class="catalog-title">学术成果</h5>
          <el-menu
            :default-active="activeIndex"
            class="menu-left"
            :router="true"
          >
            <el-menu-item
              @click="saveNavState('/academic/book')"
              index="/academic/book"
            >
              <i class="el-icon-s-management"></i>
              <span slot="title">专题著作</span>
            </el-menu-item>
            <el-menu-item
              @click="saveNavState('/academic/paper')"
              index="/academic/paper"
            >
              <template slot="title">
                <i class="el-icon-document"></i>
                <span>学术论文</span>
              </template>
            </el-menu-item>
            <el-menu-item
              @click="saveNavState('/academic/patent')"
              index="/academic/patent"
            >
              <i class="el-icon-medal"></i>
              <span slot="title">成果专利</span>
            </el-menu-item>
            <el-menu-item
              @click="saveNavState('/academic/software')"
              index="/academic/software"
            >
              <i class="el-icon-set-up"></i>
              <span slot="title">软件著作</span>
            </el-menu-item>
            <el-menu-item
              @click="saveNavState('/academic/projects')"
              index="/academic/projects"
            >
              <i class="el-icon-files"></i>
              <span slot="title">科研项目（部分）</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "/academic/book", //默认
    };
  },
  created() {
    var activeIndex = this.$route.query.path
    this.activeIndex = window.sessionStorage.getItem("academicactivePath");
    console.log(activeIndex)
    if (activeIndex !== undefined ){
        this.saveNavState(activeIndex)
    } else if (this.activeIndex!==null){
      this.saveNavState(this.activeIndex)
    } else {
      this.saveNavState("/academic/book")
    }
  },
  methods: {
    saveNavState(activePath) {
      window.sessionStorage.setItem("academicactivePath", activePath);
      this.activeIndex = activePath;
      this.$router.push(activePath)
    },
  },
  // created() {
  //   this.activeIndex = window.sessionStorage.getItem("activePath");
  // },
  // methods: {
  //   saveNavState(activePath) {
  //     console.log(this);
  //     window.sessionStorage.setItem("activePath", activePath);
  //     this.activeIndex = activePath;
  //   },
  // },
};
</script>

<style lang='less' scoped>
#academic {
  margin: 0 auto;
  .catalog {
    margin-top: 30px;
    .catalog-title {
      text-align: center;
    }
  }
}
</style>
